import * as bootstrap from "bootstrap";

const get_modal = (id) => {
    const element = document.getElementById(id);
    return element ? bootstrap.Modal.getOrCreateInstance(element) : null;
};

const login_join_modal_element = document.getElementById("oi-login-join-modal");
const login_join_modal = get_modal("oi-login-join-modal");
const password_forgot_modal = get_modal("oi-password-forgot-modal");
const password_change_modal = get_modal("oi-password-change-modal");
const onboarding_modal_element = document.getElementById("oi-onboarding-modal");
const onboarding_modal = get_modal("oi-onboarding-modal");
const welcome_modal_element = document.getElementById("oi-welcome-modal");
const welcome_modal = get_modal("oi-welcome-modal");
const confirmation_modal_element = document.getElementById("oi-confirmation-modal");
const confirmation_modal = get_modal("oi-confirmation-modal");
const confirmation_title = confirmation_modal_element ? confirmation_modal_element.querySelector(".modal-title") : null;
const confirmation_message = confirmation_modal_element ? confirmation_modal_element.querySelector(".message") : null;
const login_tab_element = document.getElementById("oi-login-nav-tab");
const join_tab_element = document.getElementById("oi-join-nav-tab");

const login_modal_force = /login/.test(window.location.hash);
const join_modal_force = /join/.test(window.location.hash);
const onboarding_force = /onboarding/.test(window.location.hash);
const welcome_modal_force = /welcome/.test(window.location.hash);

const is_logged_in = () => Boolean(window.oi && oi.loaded.user && oi.loaded.user.authenticated);
const onboarding_cookie = () => oi.utils.cookie.get("onboarding", "onboarding");

let confirmation_timer;

const show_confirmation = (title, message, timeout = 4000, after_close = null) => {
    if (!confirmation_modal) {
        return;
    }
    window.clearTimeout(confirmation_timer);
    confirmation_title.textContent = title;
    confirmation_message.innerHTML = message || "";
    confirmation_modal.show();
    if (timeout) {
        confirmation_timer = window.setTimeout(() => {
            confirmation_modal.hide();
            if (after_close) {
                after_close();
            }
        }, timeout);
    }
};

const response_message = (resp, fallback) => {
    const data = resp && (resp.data || (resp.response && resp.response.data));
    return (data && data.message) || fallback;
};

const show_login_pane = () => {
    if (login_tab_element) {
        bootstrap.Tab.getOrCreateInstance(login_tab_element).show();
    }
};

const show_join_pane = () => {
    if (join_tab_element) {
        bootstrap.Tab.getOrCreateInstance(join_tab_element).show();
    }
};

const open_login = (pane = "login") => {
    if (password_forgot_modal) {
        password_forgot_modal.hide();
    }
    if (login_join_modal) {
        login_join_modal.show();
    }
    if (pane === "join") {
        show_join_pane();
    } else {
        show_login_pane();
    }
};

const after_authentication = (resp, is_new_account) => {
    if (login_join_modal) {
        login_join_modal.hide();
    }
    const user_data = resp.data && resp.data.data;
    if (user_data && user_data.retail_user) {
        new oi.user(user_data);
        if (!onboarding_cookie()) {
            onboarding_modal.show();
        } else if (!is_new_account) {
            welcome_modal.show();
        }
    }
    window.retail_user = true;
};

window.join_pane_show = show_join_pane;
window.login_pane_show = show_login_pane;
window.ifp_login_override = () => open_login();

window.addEventListener("oi.loaded.form.oi-join-form", () => {
    oi.loaded.form["oi-join-form"].addSuccessAction = (resp) => after_authentication(resp, true);
});

window.addEventListener("oi.loaded.form.oi-login-form", () => {
    oi.loaded.form["oi-login-form"].addSuccessAction = (resp) => after_authentication(resp, false);
});

window.addEventListener("oi.loaded.form.oi-password-forgot-form", () => {
    oi.loaded.form["oi-password-forgot-form"].addSuccessAction = () => {
        password_forgot_modal.hide();
        show_confirmation(
            "Check Your Email",
            "If an account exists for that email, we've sent a link to reset your password.",
            6000
        );
    };
});

window.addEventListener("oi.loaded.form.oi-password-change-form", () => {
    oi.loaded.form["oi-password-change-form"].addSuccessAction = () => {
        password_change_modal.hide();
        document.getElementById("oi-password-change-form").reset();
        show_confirmation("Password Updated", "Your new password is saved and you're still logged in.");
    };
});

window.addEventListener("oi.loaded.form.oi-password-forgot-change-form", () => {
    oi.loaded.form["oi-password-forgot-change-form"].addSuccessAction = () => {
        const slug = window.oi_preload.dashboard_slug || "my-portal";
        show_confirmation("Password Updated", "Your password has been changed. Taking you to your account now.", 0);
        window.setTimeout(() => {
            window.location = `/${slug}/`;
        }, 2500);
    };
});

["oi-profile-form", "oi-pref-form"].forEach((form_id) => {
    window.addEventListener(`oi.loaded.form.${form_id}`, () => {
        oi.loaded.form[form_id].addSuccessAction = (resp) => {
            show_confirmation(
                form_id === "oi-profile-form" ? "Profile Saved" : "Preferences Saved",
                response_message(resp, ""),
                2500,
                () => window.location.reload()
            );
        };
    });
});

const set_realtor_fields = () => {
    const realtor_fields = document.querySelector(".ru-realtor-fields");
    const realtor_choice = document.getElementById("oi-join-form__agent_yes");
    if (realtor_fields && realtor_choice) {
        realtor_fields.hidden = !realtor_choice.checked;
    }
};

document.querySelectorAll("#oi-join-form input[name='user_type']").forEach((radio) => {
    radio.addEventListener("change", set_realtor_fields);
});
set_realtor_fields();

document.addEventListener("click", (e) => {
    const login_link = e.target.closest(".oi-login-link");
    const join_link = e.target.closest(".oi-join-link");
    const forgot_link = e.target.closest(".oi-forgot-password-link");
    const change_link = e.target.closest(".oi-password-change-link");

    if (login_link || join_link) {
        e.preventDefault();
        open_login(join_link ? "join" : "login");
        return;
    }

    if (forgot_link) {
        e.preventDefault();
        if (login_join_modal) {
            login_join_modal.hide();
        }
        password_forgot_modal.show();
        return;
    }

    if (change_link) {
        e.preventDefault();
        password_change_modal.show();
        return;
    }

    if (is_logged_in()) {
        return;
    }

    const login_required = e.target.closest(".oi-login-required");
    if (login_required) {
        e.preventDefault();
        open_login();
        if (login_required.dataset.oiUserAction === "favorite" && login_required.dataset.homefinitiId) {
            oi.state.oiuser_staged = login_required.dataset.homefinitiId;
        }
    }
});

window.addEventListener("load", () => {
    if (onboarding_modal_element) {
        onboarding_modal_element.addEventListener("shown.bs.modal", () => {
            if (!onboarding_cookie()) {
                oi.utils.cookie.set("onboarding", "onboarding");
            }
        });
        onboarding_modal_element.addEventListener("hidden.bs.modal", () => oi.utils.removeHash());
    }
    if (welcome_modal_element) {
        welcome_modal_element.addEventListener("hidden.bs.modal", () => oi.utils.removeHash());
    }
    if (login_join_modal_element) {
        login_join_modal_element.addEventListener("hidden.bs.modal", () => {
            if (/login|join/.test(window.location.hash)) {
                oi.utils.removeHash();
            }
        });
    }

    if (onboarding_force && is_logged_in()) {
        onboarding_modal.show();
    } else if (welcome_modal_force && is_logged_in()) {
        welcome_modal.show();
    } else if (is_logged_in() && !onboarding_cookie()) {
        onboarding_modal.show();
    }

    if (!is_logged_in() && (login_modal_force || join_modal_force)) {
        open_login(join_modal_force ? "join" : "login");
    }

    window.addEventListener("hashchange", () => {
        if (!is_logged_in() && /login|join/.test(window.location.hash)) {
            open_login(/join/.test(window.location.hash) ? "join" : "login");
        }
    });

    document.querySelectorAll(".delete-ifp").forEach((button) => {
        button.addEventListener("click", () => {
            const card = button.closest(".oi-saved-ifp-card");
            oi.axios({
                method: "delete",
                url: `/ifp/saved/${button.dataset.uuid}/`,
            })
                .then((resp) => {
                    card.remove();
                    const remaining = document.querySelectorAll(".oi-saved-ifp-card").length;
                    const count = document.querySelector("#ifp-tab .dashboard-tab-count");
                    if (count) {
                        count.textContent = remaining;
                    }
                    const option = document.querySelector('#dashboard-tabs-select option[value="#ifp"]');
                    if (option) {
                        option.textContent = option.textContent.replace(/\(\d+\)/, `(${remaining})`);
                    }
                    show_confirmation(
                        "Floor Plan Removed",
                        response_message(resp, ""),
                        4000,
                        remaining ? null : () => window.location.reload()
                    );
                })
                .catch((err) => {
                    show_confirmation("Something Went Wrong", response_message(err, "We couldn't remove that floor plan. Please try again."));
                });
        });
    });
});

const dashboard_tabs = document.getElementById("dashboard-tabs");

if (dashboard_tabs) {
    const tab_links = dashboard_tabs.querySelectorAll(".nav-link[data-bs-target]");
    const tab_select = document.getElementById("dashboard-tabs-select");

    if (tab_select) {
        tab_links.forEach((tab_link) => {
            const option = document.createElement("option");
            const count = tab_link.querySelector(".dashboard-tab-count");
            const label = [...tab_link.childNodes]
                .filter((node) => node.nodeType === Node.TEXT_NODE)
                .map((node) => node.textContent)
                .join("")
                .trim();
            option.value = tab_link.dataset.bsTarget;
            option.textContent = count ? `${label} (${count.textContent.trim()})` : label;
            option.selected = tab_link.classList.contains("active");
            tab_select.appendChild(option);
        });
    }

    const show_tab = (panel_id, scroll = false) => {
        const tab_link = dashboard_tabs.querySelector(`.nav-link[data-bs-target="#${panel_id}"]`);
        if (!tab_link) {
            return false;
        }
        bootstrap.Tab.getOrCreateInstance(tab_link).show();
        if (scroll) {
            const is_select = tab_select && tab_select.offsetParent !== null;
            const site_nav = document.getElementById("site-nav");
            const anchor = is_select ? tab_select : document.getElementById("dashboard-tabs-content");
            const offset = (site_nav ? site_nav.offsetHeight : 0) + 24;
            const top = anchor.getBoundingClientRect().top + window.scrollY - offset;
            if (window.scrollY > top) {
                window.scrollTo({ top, behavior: "smooth" });
            }
        }
        return true;
    };

    const show_hash_tab = () => {
        const panel_id = window.location.hash.slice(1);
        if (panel_id) {
            show_tab(panel_id, true);
        }
    };

    tab_links.forEach((tab_link) => {
        tab_link.addEventListener("shown.bs.tab", (event) => {
            const hash = event.target.dataset.bsTarget;
            if (window.location.hash !== hash) {
                window.history.replaceState(null, "", hash);
            }
            if (tab_select) {
                tab_select.value = hash;
            }
        });
    });

    if (tab_select) {
        tab_select.addEventListener("change", () => show_tab(tab_select.value.slice(1)));
    }

    document.querySelectorAll("[data-dashboard-tab]").forEach((link) => {
        link.addEventListener("click", (e) => {
            if (show_tab(link.dataset.dashboardTab, true)) {
                e.preventDefault();
            }
        });
    });

    window.addEventListener("hashchange", show_hash_tab);
    show_hash_tab();
    window.addEventListener("load", () => window.setTimeout(show_hash_tab, 0));

    const filter_buttons = document.querySelectorAll("[data-favorites-filter]");
    const favorite_groups = document.querySelectorAll("[data-favorites-group]");

    filter_buttons.forEach((button) => {
        button.addEventListener("click", () => {
            const filter = button.dataset.favoritesFilter;
            filter_buttons.forEach((other) => {
                const is_active = other === button;
                other.classList.toggle("is-active", is_active);
                other.setAttribute("aria-pressed", is_active ? "true" : "false");
            });
            favorite_groups.forEach((group) => {
                group.hidden = filter !== "all" && group.dataset.favoritesGroup !== filter;
            });
        });
    });
}
